import { Model, modelRegistry } from './Model';
import { Table, User, Order } from '../models';
/**
 * Represents a QR order request submitted by a guest.
 *
 * Unlike Order, an OrderRequest has no shift, cash register, or user context.
 * Staff CLAIM it (status pending → approved) and the approving terminal issues a
 * real Order through the normal frontend pipeline, then links it back via
 * order_hash/order_id. The request persists through its whole lifecycle
 * (pending → approved/rejected) — it is never deleted — so a lost approve can be
 * recovered and a rejection (with reason) stays visible to the guest.
 */
export class OrderRequest extends Model {
    static entity = 'order_requests';
    static primaryKey = 'id';
    static syncable = false;
    id = 0;
    table_id = 0;
    note = null;
    items = [];
    status = 'pending';
    reject_reason = null;
    order_hash = null;
    order_id = null;
    created_at = null;
    constructor(record) {
        super();
        this.$fill(record);
    }
    static fields() {
        return {
            id: this.attr(0),
            table_id: this.attr(0),
            note: this.attr(null),
            items: this.attr([]),
            status: this.attr('pending'),
            reject_reason: this.attr(null),
            order_hash: this.attr(null),
            order_id: this.attr(null),
            created_at: this.attr(null),
        };
    }
    // --- Queries ---
    /** Pending requests for a table (still awaiting staff action). */
    static forTable(tableId) {
        return OrderRequest.all().filter(r => r.table_id === tableId && r.status === 'pending');
    }
    /** True while the request still needs staff action (shown in the hub). */
    isPending() {
        return this.status === 'pending';
    }
    // --- Instance helpers ---
    getTable() {
        return Table.find(this.table_id);
    }
    getTableName() {
        return this.getTable()?.name || `#${this.table_id}`;
    }
    /**
     * The waiter serving this request's table: the owner of its open rounds
     * under the floor plan's one ownership rule. Undefined on a free table.
     * Callers walking many requests pass the open rounds once instead of
     * letting every request scan the order store again.
     */
    getTableOwner(onTables = Order.onTables()) {
        return User.getTableOwner(onTables.filter(o => o.table_id === this.table_id));
    }
}
export default OrderRequest;
modelRegistry.register('OrderRequest', OrderRequest);
//# sourceMappingURL=OrderRequest.js.map